import { Banner } from "@jkast90/kast-common/ui";
import { bannerStore } from "../../utils/bannerStore";
import styles from "../../styles/Banners.module.css";

/** The newest banner at the top of a dialog (the nav bar's is behind it). */
export default function DialogBanner() {
  return (
    <Banner
      store={bannerStore}
      className={styles.dialog}
      dismissLabel="Close banner"
    />
  );
}
